import { useQuery } from '@tanstack/react-query';
import {
  recordsApi,
  type MyPrescriptionsResponse,
  type PortalPrescriptionDto,
} from '../infrastructure/records.api';

// Query keys for the portal records feature (prescriptions only — lab reports are a deferred GAP, see
// .ai/BusinessDomain, so there is no reports query yet).
export const recordKeys = {
  all: ['portal-records'] as const,
  prescriptionList: () => ['portal-records', 'prescriptions'] as const,
  prescription: (visitId: string) => ['portal-records', 'prescriptions', visitId] as const,
};

/** Read — the patient's own prescriptions, summarised per visit. */
export function useMyPrescriptionsQuery() {
  return useQuery<MyPrescriptionsResponse>({
    queryKey: recordKeys.prescriptionList(),
    queryFn: () => recordsApi.listPrescriptions(),
  });
}

/** Read — full prescription detail for one visit. Enabled only once a visitId is selected (e.g. for a detail modal). */
export function useMyPrescriptionQuery(visitId: string | undefined) {
  return useQuery<PortalPrescriptionDto>({
    queryKey: recordKeys.prescription(visitId ?? ''),
    queryFn: () => recordsApi.getPrescription(visitId as string),
    enabled: Boolean(visitId),
  });
}
